var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KImg',{staticClass:"img",attrs:{"src":"","isDecorative":"","aspectRatio":"16:9"},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('span',{staticClass:"placeholder"},[_c('KIcon',{staticClass:"icon",attrs:{"icon":"readSolid"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }